<template>
  <a-drawer
    class="detail-drawer"
    :closable="false"
    :body-style="{ padding: '8px 16px', overflow: 'hidden' }"
    :destroy-on-close="true"
    :visible="visible"
    :width="1080"
    @close="closeDrawer"
  >
    <a-tabs v-model="tabKey" v-if="detail.id">
      <a-tab-pane key="overview" tab="总览">
        <a-row
          :gutter="16"
          style="flex-flow: nowrap; height: calc(100vh - 80px); overflow: auto"
        >
          <!-- 健康仪表盘 -->
          <a-col :span="8" style="margin-bottom: 16px">
            <div class="module-container" style="height: 208px">
              <div
                style="
                  height: 60px;
                  margin-bottom: 8px;
                  display: grid;
                  grid-template-rows: 1fr 1fr;
                  justify-items: center;
                  grid-template-columns: 2fr 3fr;
                  line-height: 30px;
                "
              >
                <div style="color: rgba(0, 0, 0, 0.5); font-size: 12px">
                  资源状态
                </div>
                <source-status-tag :status="detail.status"></source-status-tag>
                <div style="color: rgba(0, 0, 0, 0.5); font-size: 12px">
                  监控状态
                </div>
                <div>
                  <monitor-status-tag
                    v-for="item in monitorStatuses"
                    :key="item.name"
                    :status="item.value"
                    :name="item.name"
                  ></monitor-status-tag>
                </div>
              </div>
              <dashboard-chart
                v-if="showScoreChart"
                chart-id="overview-health-chart"
                :height="110"
                :chart-data="dashboardData"
              ></dashboard-chart>
            </div>
          </a-col>
          <a-col :span="8" style="margin-bottom: 16px">
            <div class="module-container" style="height: 208px">
              <div class="module-header-fs14" style="margin-bottom: 14px;">软件信息</div>
              <div
                style="
                  position: absolute;
                  right: 10px;
                  top: 12px;
                  font-size: 11px;
                "
              >
                <a @click="$refs.hardwareModal.show()">更多</a>
              </div>

              <hardware-description :detail="detail"></hardware-description>
              <info-modal ref="hardwareModal" class="description-in-modal">
                <template>
                  <hardware-description :detail="detail" :show-more="true"></hardware-description>
                </template>
              </info-modal>
            </div>
          </a-col>
          <!-- 监控信息 -->
          <a-col :span="8" style="margin-bottom: 16px">
            <div class="module-container" style="height: 208px">
              <div class="module-header-fs14" style="margin-bottom: 14px;">监控信息</div>
              <a-descriptions
                :column="1"
                class="description-overflow-hidden description-item-12px"
              >
                <a-descriptions-item label="ID">
                  <content-tooltip
                    v-if="detail.id"
                    :title="detail.id.replaceAll('-', '')"
                    :body="detail.id.replaceAll('-', '')"
                  ></content-tooltip>
                  <span v-else>-</span>
                </a-descriptions-item>
                <a-descriptions-item label="所属群组">
                  <a-tag v-for="group in detail.groups" :key="group.id">
                    {{ group.name }}
                  </a-tag>
                </a-descriptions-item>
                <a-descriptions-item label="IP 地址">
                  <content-tooltip
                    v-if="detail.monitor_address"
                    :title="detail.monitor_address"
                    :body="detail.monitor_address"
                  ></content-tooltip>
                  <span v-else>-</span>
                </a-descriptions-item>
                <a-descriptions-item label="监控端口">
                  <content-tooltip
                    v-if="detail.monitor_port"
                    :title="detail.monitor_port"
                    :body="detail.monitor_port"
                  ></content-tooltip>
                  <span v-else>-</span>
                </a-descriptions-item>
              </a-descriptions>
            </div>
          </a-col>
          <!-- 健康情况 -->
          <a-col :span="24" style="margin-bottom: 16px">
            <div
              class="module-container health-module-container"
              style="min-height: 340px; max-height: 470px"
            >
              <div class="module-header-fs14" style="position: absolute; top: 16px;">性能情况</div>
              <a-col :span="12" style="padding-top: 32px;">
                <usage-chart
                  :chartData="healthyUsage"
                  chart-id="os-healthy-usage-chart"
                ></usage-chart>
              </a-col>
            </div>
          </a-col>
          <!-- 告警情况 -->
          <a-col :span="24" style="margin-bottom: 16px">
            <div class="module-container" style="height: 430px">
              <div class="module-header-fs14" style="margin-bottom: 14px;">告警情况</div>
              <overview-alerts :dataSource="alertsData" :loading="loading"></overview-alerts>
            </div>
          </a-col>
          <!-- 风险情况 -->
          <!-- <a-col :span="24" style="margin-bottom: 16px">
            <div class="module-container" style="height: 340px">
              <div class="module-header-fs14" style="margin-bottom: 14px;">风险情况</div>
              <display-table :columns="RiskColumns"></display-table>
            </div>
          </a-col> -->
        </a-row>
      </a-tab-pane>

      <a-tab-pane key="processes" tab="进程">
        <processes-page :detail="detail"></processes-page>
      </a-tab-pane>

      <a-tab-pane key="network-interface" tab="端口">
        <port-page :detail="detail"></port-page>
      </a-tab-pane>

      <a-tab-pane key="software-info" tab="软件">
        <software-info-page :detail="detail"></software-info-page>
      </a-tab-pane>

      <a-tab-pane key="filesystem" tab="文件系统">
        <filesystem-page :detail="detail"></filesystem-page>
      </a-tab-pane>

      <a-tab-pane key="software" tab="软件运行情况">
        <software-page :detail="detail"></software-page>
      </a-tab-pane>

      <a-tab-pane key="network" tab="网络运行情况">
        <network-page :detail="detail"></network-page>
      </a-tab-pane>

      <a-tab-pane key="monitor" tab="指标详情">
        <div
          style="
            padding: 0 16px;
            flex-flow: nowrap;
            height: calc(100vh - 80px);
            overflow: auto;
          "
        >
          <monitor-item-table
            :get-func="getItemListFunc"
            :history-func="historyFunc"
            :source-id="detail.id"
          ></monitor-item-table>
        </div>
      </a-tab-pane>

      <a-tab-pane key="rule" tab="告警规则">
        <div
          style="
            padding: 0 16px;
            flex-flow: nowrap;
            height: calc(100vh - 80px);
            overflow: auto;
          "
        >
          <monitor-trigger-table
            :get-func="getTriggerFunc"
            :source-id="detail.id"
            :update-func="updateFunc"
          ></monitor-trigger-table>
        </div>
      </a-tab-pane>
    </a-tabs>
  </a-drawer>
</template>

<script>
import store from '@/store'
import {
  getOS,
  getOSAlertList,
  getOSMonitorStatusList,
  getOSMonitorItemList,
  updateOSMonitorTrigger,
  getOSMonitorHistory,
  getOSMonitorTriggerList,
  getOSHealthScore
} from '@/api/os'
import MonitorStatusTag from '@/components/tag/MonitorStatusTag'
import ContentTooltip from '@/components/ContentTooltip'
import SourceStatusTag from '@/components/tag/SourceStatusTag'

import DashboardChart from '@/components/chart/DashboardChart'
import HardwareDescription from './modules/HardwareDescription'
import InfoModal from '@/components/source-detail-page/InfoModal'
import UsageChart from '@/components/source-detail-page/UsageChart'
// import DisplayTable from '@/components/source-detail-page/DisplayTable'
import MonitorItemTable from '@/components/table/MonitorItemTable'
import MonitorTriggerTable from '@/components/table/MonitorTriggerTable'
import OverviewAlerts from '@/components/source-detail-page/OverviewAlerts.vue'

import NetworkPage from './NetworkPage/index.vue'
import SoftwarePage from './SoftwarePage/index.vue'
import SoftwareInfoPage from './SoftwareInfoPage/index.vue'
import ProcessesPage from './ProcessesPage/index.vue'
import FilesystemPage from './FilesystemPage/index.vue'
import PortPage from './PortPage/index.vue'

const hardwareStatusKeys = [
  { key: 'system.cpu.util', type: 'cpu' },
  { key: 'vm.memory.util', type: 'memory' },
  { key: 'vfs.disk.util', type: 'disk' }
]

export default {
  name: 'OSDrawer',
  components: {
    MonitorStatusTag,
    DashboardChart,
    HardwareDescription,
    InfoModal,
    ContentTooltip,
    UsageChart,
    // DisplayTable,
    MonitorItemTable,
    MonitorTriggerTable,
    NetworkPage,
    SoftwarePage,
    ProcessesPage,
    OverviewAlerts,
    SourceStatusTag,
    FilesystemPage,
    SoftwareInfoPage,
    PortPage
  },
  data () {
    return {
      tabKey: 'overview',
      visible: false,
      baseInfoDisplay: false,
      getItemListFunc: getOSMonitorItemList,
      historyFunc: getOSMonitorHistory,
      getTriggerFunc: getOSMonitorTriggerList,
      updateFunc: updateOSMonitorTrigger,
      monitorStatuses: [],
      detail: {
        id: '',
        name: '',
        hostname: '',
        cpu: '',
        memory: '',
        os_type: 'unknown',
        version: '',
        monitor_address: '',
        created_at: '',
        updated_at: '',
        groups: [],
        status: 'unknown'
      },
      healthyUsage: [
        {
          type: 'cpu_usage',
          name: 'CPU',
          value: 0
        },
        {
          type: 'memory_usage',
          name: '内存',
          value: 0
        },
        {
          type: 'disk_usage',
          name: '磁盘',
          value: 0
        }
      ],
      loading: false,
      alertsData: [],
      RiskColumns: [
        {
          dataIndex: 'type',
          align: 'center',
          title: '风险分类',
          width: 80,
          scopedSlots: {
            customRender: 'type'
          }
        },
        {
          dataIndex: 'monitor',
          align: 'center',
          title: '监控项',
          width: 80,
          scopedSlots: {
            customRender: 'monitor'
          }
        },
        {
          dataIndex: 'current_monitor',
          align: 'center',
          title: '当前指标',
          width: 80,
          scopedSlots: {
            customRender: 'currentMonitor'
          }
        },
        {
          dataIndex: 'description',
          align: 'description',
          title: '描述',
          width: 80,
          scopedSlots: {
            customRender: 'description'
          }
        }
      ],
      showScoreChart: false,
      dashboardData: []
    }
  },
  methods: {
    show (id) {
      getOS(id)
        .then(res => {
          this.detail = res.data
          this.fetchUsage(id)
        })
        .finally(() => {
          this.visible = true
        })
      getOSMonitorStatusList(id).then(res => {
        this.monitorStatuses = res.data.data
      })
      this.loading = true
      const params = {
        recovered: false,
        source_id: id
      }
      getOSAlertList(params).then(res => {
        this.alertsData = res.data.data
      }).finally(() => {
        this.loading = false
      })
      getOSHealthScore(id).then(res => {
        this.dashboardData = [{ value: res.data }]
      }).finally(() => {
        this.showScoreChart = true
      })
    },
    fetchUsage (id) {
      const arr = [
        {
          type: 'cpu_usage',
          name: 'CPU',
          value: 0
        },
        {
          type: 'memory_usage',
          name: '内存',
          value: 0
        },
        {
          type: 'disk_usage',
          name: '磁盘',
          value: 0
        }
      ]
      Promise.all(hardwareStatusKeys.map(keyObj => new Promise((resolve, reject) => {
        getOSMonitorItemList(id, { key: keyObj.key }).then(res => {
          const data = res.data.data
          if (data.length) {
            const v = data[0].value * 1
            resolve(v)
          } else resolve(0)
        }).catch(err => {
          reject(err)
        })
      }))).then(res => {
        arr.forEach((item, i) => {
          item.value = res[i]
        })
        this.healthyUsage = arr
        this.detail.cpu_usage = res[0]
        this.detail.memory_usage = res[1]
        this.detail.disk_usage = res[2]
      })
    },
    closeDrawer () {
      this.visible = false
      store.state.cancelRequest.promiseArr.forEach((e, index) => {
        e.cancel('取消请求')
      })
      store.commit('cancelRequest/CLEAR_PROMISE_ARR')
      this.detail = {
        id: '',
        name: '',
        hostname: '',
        cpu: '',
        memory: '',
        os_type: 'unknown',
        version: '',
        monitor_address: '',
        created_at: '',
        updated_at: '',
        groups: [],
        status: 'unknown'
      }
      this.tabKey = 'overview'
      this.healthyUsage = [
        {
          type: 'cpu_usage',
          name: 'CPU',
          value: 0
        },
        {
          type: 'memory_usage',
          name: '内存',
          value: 0
        },
        {
          type: 'disk_usage',
          name: '磁盘',
          value: 0
        }
      ]
      this.alertsData = []
      this.healthyStatus = []
      this.monitorStatuses = []
      this.showScoreChart = false
    }
  }
}
</script>
